export default __webpack_public_path__ + "static/media/2339.dcf64405.png";